import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthProvider'

/**
 * Redirects to the correct login page if user is not authenticated.
 * Context-aware: inspects the current path to determine which login page to use.
 *
 *   /platform/*     → /platform/login
 *   /paragon/*      → /paragon/login
 *   /:slug/admin/*  → /origin/login  (tenant admins use Origin login)
 *   everything else → /origin/login
 */
export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-2 border-t-transparent border-white/30" />
      </div>
    )
  }

  if (!user) {
    const path = location.pathname

    let loginTarget = '/origin/login'
    if (path.startsWith('/platform')) {
      loginTarget = '/platform/login'
    } else if (path.startsWith('/paragon')) {
      loginTarget = '/paragon/login'
    }

    return <Navigate to={loginTarget} state={{ from: location }} replace />
  }

  return <>{children}</>
}
